export const actionTypes = {
  service: 'service',
  tag: 'tag',
} as const;

export const itemType = {
  blocked: 'blocked',
  blocking: 'blocking',
} as const;

export const serviceStatuses = {
  executed: 'executed',
  failed: 'failed',
} as const;
